// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../../App.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/images/branding/fondo-berry-banner.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.banner-berryfields-container {
  width: 100%;
  height: auto;
  background-color: var(--color-blue-cream-special);
}

.banner-berryfields-container .background-overlay {
  width: 100%;
  height: auto;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.banner-berryfields-container .background-overlay .container {
  width: 85% !important;
  margin: auto;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 60px 0px;
}

.banner-berryfields-container .background-overlay .container .text-container {
  width: 65%;
}

.banner-berryfields-container .background-overlay .container .text-container h2 {
  font-family: "Lexend Deca", sans-serif;
  line-height: 60px;
  font-weight: bolder;
  font-size: 48px;
  color: var(--color-blue-dark);
}

.banner-berryfields-container .background-overlay .container .text-container h2 img {
  display: inline !important;
  max-width: auto;
  height: 60px;
  position: absolute;
  margin-left: 15px;
}

.banner-berryfields-container .background-overlay .container .image-container {
  width: 35%;
  height: auto;
  display: flex;
  justify-content: center;
}

.banner-berryfields-container .background-overlay .container .image-container img {
  max-width: 68vw;
  display: block;
  margin: auto;
}

.banner-berryfields-container .background-overlay .container .text-container .row-span {
  width: max-content;
  display: flex;
  margin-top: 25px;
  padding: 20px 0px;
  border-top: 4px solid var(--color-blue-dark);
  border-bottom: 1px solid var(--color-blue-dark);
}

.banner-berryfields-container .background-overlay .container .text-container .row-span .col-span {
  display: flex;
  align-items: center;
}

.banner-berryfields-container .background-overlay .container .text-container .row-span .col-span .icon {
  width: 60px;
  height: 60px;
  font-size: 25px;
  border-radius: 100%;
  background-color: var(--color-white-main);
  color: var(--color-blue-dark);
  text-align: center;
  line-height: 60px;
  margin: 0px 15px 0px 0px;
}

.banner-berryfields-container .background-overlay .container .text-container .row-span .divider {
  display: block;
  width: 2px;
  height: auto;
  background-color: var(--color-blue-dark);
  margin: 0px 45px;
}

.banner-berryfields-container .background-overlay .container .text-container .row-span .col-span .text {
  width: auto;
}

.banner-berryfields-container .background-overlay .container .text-container .row-span .col-span .text span {
  display: block;
  text-transform: uppercase;
  font-family: "Lexend Deca", sans-serif;
  color: var(--color-blue-dark);
}

.banner-berryfields-container .background-overlay .container .text-container .row-span .col-span .text .text-lighter {
  font-weight: 500;
  font-size: 13px;
}

.banner-berryfields-container .background-overlay .container .text-container .row-span .col-span .text .text-bolder {
  font-weight: bolder;
  font-size: 20px;
}

.banner-berryfields-container .background-overlay .container .text-container .data-contact {
  width: 100%;
  margin-top: 20px;
}

.banner-berryfields-container .background-overlay .container .text-container .data-contact ul {
  display: flex;

}

.banner-berryfields-container .background-overlay .container .text-container .data-contact ul li {
  list-style: none;
  margin: 0px 45px 0px 0px;
  font-weight: 600;
  font-family: "Lexend Deca", sans-serif;
  font-size: 14px;
  color: var(--color-blue-dark);
}

.banner-berryfields-container .background-overlay .container .text-container .data-contact ul li i {
  margin: 0px 5px 0px 0px;
}

@media only screen and (max-width: 600px) {
  .banner-berryfields-container {
    height: 98vh;
  }

  .banner-berryfields-container .background-overlay .container {
    width: 90% !important;
    margin: auto;
    height: 105vh;
    display: flex;
    flex-direction: column;
    padding: 11px 0px;
  }

  .banner-berryfields-container .background-overlay .container .text-container {
    width: 100%;
    height: auto;
  }

  .banner-berryfields-container .background-overlay .container .text-container h1 {
    font-size: 32px;
    line-height: 40px;
  }

  .banner-berryfields-container .background-overlay .container .text-container h1 img {
    display: inline !important;
    max-width: auto;
    height: 40px;
    position: absolute;
    margin-left: 10px;
  }

  .banner-berryfields-container .background-overlay .container .text-container .row-span {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 7px;
    padding: 20px 0px;
  }

  .banner-berryfields-container .background-overlay .container .text-container .row-span .col-span {
    display: flex;
  }

  .banner-berryfields-container .background-overlay .container .text-container .row-span .divider {
    display: block;
    width: 100%;
    height: 2px;
    margin: 12px 0px;
  }

  .banner-berryfields-container .background-overlay .container .text-container .data-contact ul {
    display: flex;
    flex-direction: column;
  }

  .banner-berryfields-container .background-overlay .container .text-container .data-contact ul li {
    margin: 0px 0px 15px 0px;
  }

  .banner-berryfields-container .background-overlay .container .image-container {
    width: 100%;
    height: auto;
    margin: 78px;
    position: relative;
  }

  .banner-berryfields-container .background-overlay .container .text-container h2 {
    font-size: 27px;
  }

  .banner-berryfields-container .background-overlay .container .text-container .row-span .col-span .text .text-lighter {
    font-size: 10px;
  }

  .banner-berryfields-container .background-overlay .container .text-container .row-span .col-span .text .text-bolder {
    font-size: 17px;
  }

  .banner-berryfields-container .background-overlay .container .text-container .row-span .col-span .icon {
    width: 43px;
    height: 42px;
    font-size: 19px;
    line-height: 44px;
  }
  .banner-berryfields-container .background-overlay .container .image-container img {
    position: relative;
    bottom: 81px;
  }
}


@media only screen and (min-width: 601px) and (max-width: 1024px) {
  .banner-berryfields-container .background-overlay .container {
    width: 90% !important;
    margin: auto;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 60px 0px;
  }

  .banner-berryfields-container .background-overlay .container .text-container {
    width: 100%;
    height: auto;
  }

  .banner-berryfields-container .background-overlay .container .text-container h1 {
    font-size: 48px;
    line-height: 60px;
  }

  .banner-berryfields-container .background-overlay .container .text-container h1 img {
    display: inline !important;
    max-width: auto;
    height: 60px;
    position: absolute;
    margin-left: 10px;
  }

  .banner-berryfields-container .background-overlay .container .text-container .row-span {
    width: 100%;
    display: flex;
    margin-top: 25px;
    padding: 20px 0px;
  }

  .banner-berryfields-container .background-overlay .container .text-container .row-span .col-span {
    display: flex;
  }

  .banner-berryfields-container .background-overlay .container .text-container .data-contact ul {
    display: flex;
  }

  .banner-berryfields-container .background-overlay .container .text-container .data-contact ul li {
    margin: 0px 45px 0px 0px;
  }

  .banner-berryfields-container .background-overlay .container .image-container {
    width: 100%;
    height: auto;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/layouts/banner-berryfields/BannerBerryFields.css"],"names":[],"mappings":"AAEA;EACE,WAAW;EACX,YAAY;EACZ,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mDAAyE;AAC3E;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sCAAsC;EACtC,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,4CAA4C;EAC5C,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,yCAAyC;EACzC,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,UAAU;EACV,YAAY;EACZ,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,sCAAsC;EACtC,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;;AAEf;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,sCAAsC;EACtC,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,qBAAqB;IACrB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,WAAW;IACX,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,YAAY;EACd;AACF;;;AAGA;EACE;IACE,qBAAqB;IACrB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":["@import url(../../../App.css);\n\n.banner-berryfields-container {\n  width: 100%;\n  height: auto;\n  background-color: var(--color-blue-cream-special);\n}\n\n.banner-berryfields-container .background-overlay {\n  width: 100%;\n  height: auto;\n  background: url(\"../../../assets/images/branding/fondo-berry-banner.png\");\n}\n\n.banner-berryfields-container .background-overlay .container {\n  width: 85% !important;\n  margin: auto;\n  height: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 60px 0px;\n}\n\n.banner-berryfields-container .background-overlay .container .text-container {\n  width: 65%;\n}\n\n.banner-berryfields-container .background-overlay .container .text-container h2 {\n  font-family: \"Lexend Deca\", sans-serif;\n  line-height: 60px;\n  font-weight: bolder;\n  font-size: 48px;\n  color: var(--color-blue-dark);\n}\n\n.banner-berryfields-container .background-overlay .container .text-container h2 img {\n  display: inline !important;\n  max-width: auto;\n  height: 60px;\n  position: absolute;\n  margin-left: 15px;\n}\n\n.banner-berryfields-container .background-overlay .container .image-container {\n  width: 35%;\n  height: auto;\n  display: flex;\n  justify-content: center;\n}\n\n.banner-berryfields-container .background-overlay .container .image-container img {\n  max-width: 68vw;\n  display: block;\n  margin: auto;\n}\n\n.banner-berryfields-container .background-overlay .container .text-container .row-span {\n  width: max-content;\n  display: flex;\n  margin-top: 25px;\n  padding: 20px 0px;\n  border-top: 4px solid var(--color-blue-dark);\n  border-bottom: 1px solid var(--color-blue-dark);\n}\n\n.banner-berryfields-container .background-overlay .container .text-container .row-span .col-span {\n  display: flex;\n  align-items: center;\n}\n\n.banner-berryfields-container .background-overlay .container .text-container .row-span .col-span .icon {\n  width: 60px;\n  height: 60px;\n  font-size: 25px;\n  border-radius: 100%;\n  background-color: var(--color-white-main);\n  color: var(--color-blue-dark);\n  text-align: center;\n  line-height: 60px;\n  margin: 0px 15px 0px 0px;\n}\n\n.banner-berryfields-container .background-overlay .container .text-container .row-span .divider {\n  display: block;\n  width: 2px;\n  height: auto;\n  background-color: var(--color-blue-dark);\n  margin: 0px 45px;\n}\n\n.banner-berryfields-container .background-overlay .container .text-container .row-span .col-span .text {\n  width: auto;\n}\n\n.banner-berryfields-container .background-overlay .container .text-container .row-span .col-span .text span {\n  display: block;\n  text-transform: uppercase;\n  font-family: \"Lexend Deca\", sans-serif;\n  color: var(--color-blue-dark);\n}\n\n.banner-berryfields-container .background-overlay .container .text-container .row-span .col-span .text .text-lighter {\n  font-weight: 500;\n  font-size: 13px;\n}\n\n.banner-berryfields-container .background-overlay .container .text-container .row-span .col-span .text .text-bolder {\n  font-weight: bolder;\n  font-size: 20px;\n}\n\n.banner-berryfields-container .background-overlay .container .text-container .data-contact {\n  width: 100%;\n  margin-top: 20px;\n}\n\n.banner-berryfields-container .background-overlay .container .text-container .data-contact ul {\n  display: flex;\n\n}\n\n.banner-berryfields-container .background-overlay .container .text-container .data-contact ul li {\n  list-style: none;\n  margin: 0px 45px 0px 0px;\n  font-weight: 600;\n  font-family: \"Lexend Deca\", sans-serif;\n  font-size: 14px;\n  color: var(--color-blue-dark);\n}\n\n.banner-berryfields-container .background-overlay .container .text-container .data-contact ul li i {\n  margin: 0px 5px 0px 0px;\n}\n\n@media only screen and (max-width: 600px) {\n  .banner-berryfields-container {\n    height: 98vh;\n  }\n\n  .banner-berryfields-container .background-overlay .container {\n    width: 90% !important;\n    margin: auto;\n    height: 105vh;\n    display: flex;\n    flex-direction: column;\n    padding: 11px 0px;\n  }\n\n  .banner-berryfields-container .background-overlay .container .text-container {\n    width: 100%;\n    height: auto;\n  }\n\n  .banner-berryfields-container .background-overlay .container .text-container h1 {\n    font-size: 32px;\n    line-height: 40px;\n  }\n\n  .banner-berryfields-container .background-overlay .container .text-container h1 img {\n    display: inline !important;\n    max-width: auto;\n    height: 40px;\n    position: absolute;\n    margin-left: 10px;\n  }\n\n  .banner-berryfields-container .background-overlay .container .text-container .row-span {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    margin-top: 7px;\n    padding: 20px 0px;\n  }\n\n  .banner-berryfields-container .background-overlay .container .text-container .row-span .col-span {\n    display: flex;\n  }\n\n  .banner-berryfields-container .background-overlay .container .text-container .row-span .divider {\n    display: block;\n    width: 100%;\n    height: 2px;\n    margin: 12px 0px;\n  }\n\n  .banner-berryfields-container .background-overlay .container .text-container .data-contact ul {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .banner-berryfields-container .background-overlay .container .text-container .data-contact ul li {\n    margin: 0px 0px 15px 0px;\n  }\n\n  .banner-berryfields-container .background-overlay .container .image-container {\n    width: 100%;\n    height: auto;\n    margin: 78px;\n    position: relative;\n  }\n\n  .banner-berryfields-container .background-overlay .container .text-container h2 {\n    font-size: 27px;\n  }\n\n  .banner-berryfields-container .background-overlay .container .text-container .row-span .col-span .text .text-lighter {\n    font-size: 10px;\n  }\n\n  .banner-berryfields-container .background-overlay .container .text-container .row-span .col-span .text .text-bolder {\n    font-size: 17px;\n  }\n\n  .banner-berryfields-container .background-overlay .container .text-container .row-span .col-span .icon {\n    width: 43px;\n    height: 42px;\n    font-size: 19px;\n    line-height: 44px;\n  }\n  .banner-berryfields-container .background-overlay .container .image-container img {\n    position: relative;\n    bottom: 81px;\n  }\n}\n\n\n@media only screen and (min-width: 601px) and (max-width: 1024px) {\n  .banner-berryfields-container .background-overlay .container {\n    width: 90% !important;\n    margin: auto;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    padding: 60px 0px;\n  }\n\n  .banner-berryfields-container .background-overlay .container .text-container {\n    width: 100%;\n    height: auto;\n  }\n\n  .banner-berryfields-container .background-overlay .container .text-container h1 {\n    font-size: 48px;\n    line-height: 60px;\n  }\n\n  .banner-berryfields-container .background-overlay .container .text-container h1 img {\n    display: inline !important;\n    max-width: auto;\n    height: 60px;\n    position: absolute;\n    margin-left: 10px;\n  }\n\n  .banner-berryfields-container .background-overlay .container .text-container .row-span {\n    width: 100%;\n    display: flex;\n    margin-top: 25px;\n    padding: 20px 0px;\n  }\n\n  .banner-berryfields-container .background-overlay .container .text-container .row-span .col-span {\n    display: flex;\n  }\n\n  .banner-berryfields-container .background-overlay .container .text-container .data-contact ul {\n    display: flex;\n  }\n\n  .banner-berryfields-container .background-overlay .container .text-container .data-contact ul li {\n    margin: 0px 45px 0px 0px;\n  }\n\n  .banner-berryfields-container .background-overlay .container .image-container {\n    width: 100%;\n    height: auto;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
